import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("a9e05dca21", ".ccd01200e2cddb47__root{overflow:hidden;padding:0}.ccd01200e2cddb47__root .dataviews-layout__container{flex:1 1 auto}");
}
export default {"root":"ccd01200e2cddb47__root"};
